<template>
  <div>
    <section v-if="!isLoading" class="search-section">
      <SearchAutoCompleteCellList
        v-if="hasAutoCompleteCellList && !isSearchMain"
        :cell-list="autoCompleteList"
        :thumbnail-info="autoCompleteThumbnailInfo"
      />

      <SearchKeywordResult
        v-else-if="
          !hasAutoCompleteCellList && hasSearchKeyword && !isSearchMain
        "
        :isplayymovie="isplayymovie"
        :key="`searchDetail_${componentKey}`"
      />

      <SearchPopular v-else :popular-section="popularSection" />
    </section>
    <div v-else class="min-h-screen"></div>
  </div>
</template>

<script>
  /* eslint-disable */
  import axios from 'axios'
  import _ from 'lodash'
  import cookie from '@/common/utils/cookie'
  import {
    UPDATE_PAGING_CONTENT,
    UPDATE_SEARCH_CONTENT,
    SET_CURRENT_MENU,
    SEARCH_INPUT_FOCUS,
    SEARCH_TYPING_QUERY,
    SEARCH_RESULT_QUERY,
    SEARCH_AGAIN_INPUT_FOCUS,
    SEARCH_SAME_QUERY,
  } from '@/common/resources/const'
  import { mapMutations } from 'vuex'
  import {
    getThumbnailInfo,
    removePrefixEmptyString,
    scrollTop,
  } from '@/common/utils/common'
  import {
    getSearchInstanceKeywords,
    getSearchPopularContents,
  } from '@/common/utils/request'
  import SearchKeywordResult from '@/components/search/SearchKeywordResult'
  import SearchAutoCompleteCellList from '@/components/band/SearchAutoCompleteCellList'
  import SearchPopular from '@/components/search/SearchPopular'

  export default {
    name: 'SearchMain',
    components: {
      SearchKeywordResult,
      SearchAutoCompleteCellList,
      SearchPopular,
    },
    data() {
      return {
        autoCompleteList: [],
        prevAutoCompleteList: [],
        autoCompleteThumbnailInfo: {},
        searchWord: '',
        searchedQuery: '',
        popularSection: [],
        isSearchMain: true,
        isLoading: false,
        isRealtimeCellReady: false,
        componentKey: 0,
        pooqzoneInfo: cookie.getPooqZoneInfo(),
        isplayymovie: 'y', //
      }
    },
    computed: {
      hasAutoCompleteCellList() {
        return this.autoCompleteList.length > 0
      },
      hasSearchKeyword() {
        return this.searchedQuery.length > 0
      },
    },
    methods: {
      ...mapMutations([SET_CURRENT_MENU]),
      clearAutoCompleteList() {
        this.autoCompleteList = []
      },
      setPrevAutoCompleteList() {
        this.prevAutoCompleteList = []
        this.prevAutoCompleteList = this.autoCompleteList
      },
      cancelRequest() {
        this.isLoading = false
      },
      checkSearchQuery() {
        this.isSearchMain = !this.hasSearchKeyword
      },
      setAutoCompleteData(keyword) {
        this.isLoading = true
        this.searchWord = keyword
        this.setPrevAutoCompleteList()
        this.clearAutoCompleteList()
        getSearchInstanceKeywords({
          keyword: keyword,
          isplayymovie: this.isplayymovie,
          type: 'all',
        }).then(({ data }) => {
          this.autoCompleteThumbnailInfo = getThumbnailInfo(
            _.get(data, 'cell_toplist.cell_type', {}),
          )
          if (this.isLoading && this.isRealtimeCellReady) {
            const autoCompleteCellData = _.get(
              data,
              'cell_toplist.celllist',
              [],
            )
            this.autoCompleteList =
              autoCompleteCellData.length > 0
                ? autoCompleteCellData
                : this.prevAutoCompleteList
          } else {
            this.clearAutoCompleteList()
          }
          this.isLoading = false
        })
      },
      setPopularContentsData() {
        const popularArr = ['program', 'movie']
        const PATH_CELL_LIST = 'cell_toplist'
        axios
          .all(
            popularArr.map((band) =>
              getSearchPopularContents({ contenttype: band }),
            ),
          )
          .then(
            axios.spread(({ data: program }, { data: movie }) => {
              this.popularSection = [
                _.get(program, PATH_CELL_LIST, {}),
                _.get(movie, PATH_CELL_LIST, {}),
              ]
            }),
          )
          .catch((error) => {
            console.error('프로그램, 영화 리스트를 가져올 수 없습니다.', error)
          })
      },
    },
    created() {
      scrollTop()
      if (this.pooqzoneInfo && this.pooqzoneInfo.isPooqzone)
        this.isplayymovie = this.pooqzoneInfo.isplayymovie
      this.setPopularContentsData()
      this.$events.$on(SEARCH_TYPING_QUERY, (keyword) => {
        this.searchWord = keyword
      })
      this.$events.$on(SEARCH_RESULT_QUERY, (query) => {
        this.searchedQuery = query
      })
      this.$events.$on(SEARCH_AGAIN_INPUT_FOCUS, ({ isAutoCompleteReady }) => {
        this.isRealtimeCellReady = isAutoCompleteReady
      })
      this.$events.$on(SEARCH_SAME_QUERY, () => {
        this.autoCompleteList = []
      })
    },
    mounted() {
      this[SET_CURRENT_MENU]('search')
      this.$events.$on(UPDATE_SEARCH_CONTENT, () => {
        this.componentKey += 1
      })
      this.$events.$on(UPDATE_PAGING_CONTENT, () => {
        this.componentKey += 1
      })
      this.$nextTick(() => {
        this.$events.$emit(SEARCH_INPUT_FOCUS)
        this.checkSearchQuery()
      })
    },
    beforeDestroy() {
      this.$events.$off(UPDATE_SEARCH_CONTENT)
      this.$events.$off(UPDATE_PAGING_CONTENT)
      this.$events.$off(SEARCH_TYPING_QUERY)
      this.$events.$off(SEARCH_RESULT_QUERY)
      this.$events.$off(SEARCH_AGAIN_INPUT_FOCUS)
      this.$events.$off(SEARCH_SAME_QUERY)
    },
    watch: {
      searchWord(newSearchKeyword) {
        const SEARCH_WORD_IS_EMPTY =
          removePrefixEmptyString(newSearchKeyword) === ''
        if (SEARCH_WORD_IS_EMPTY) {
          this.clearAutoCompleteList()
          this.isSearchMain = true
        } else {
          this.isSearchMain = false
          this.searchWord = newSearchKeyword
          if (this.isRealtimeCellReady)
            this.setAutoCompleteData(newSearchKeyword)
        }
        scrollTop()
      },
      $route(route) {
        if (!route?.query?.searchWord) this.searchedQuery = ''
        this.isRealtimeCellReady = false
        this.checkSearchQuery()
        if (this.isLoading && !this.isRealtimeCellReady) this.cancelRequest()
      },
    },
  }
</script>
<style lang="scss" src="@/assets/scss/category/member.scss" />
<style lang="scss" scoped>
  .search-section {
    width: auto;
    overflow: hidden;
  }
</style>
